export const REQUIRED_PARAMS = [
  'code_challenge',
  'code_challenge_method',
  'client_id',
  'redirect_uri',
  'state',
  'scope',
  'response_type',
] as const;

export type OAuthParams = {
  [K in (typeof REQUIRED_PARAMS)[number]]: string;
};
